<template>
  <select
    v-model="modelValue"
    :class="`border-1 focus:shadow-outline form-select block w-full rounded-sm border-gray-300 px-4 py-2 leading-tight text-primary placeholder-slate-300 shadow-sm focus:border-main-primary focus:ring-main-primary ${classes}`"
    :required="isRequired"
    @change="$emit('valueUpdated', $event.target.value)"
  >
    <option
      v-if="firstLabel !== ''"
      :value="firstValue"
      selected
    >
      {{ firstLabel }}
    </option>
    <option
      v-for="(option, index) in sortedOptions"
      :key="`item-${index}`"
      :value="option[valueKey]"
    >
      {{ option[displayKey] }}
    </option>
  </select>
</template>

<script>
export default {
  name: 'DropDown',
  props: {
    firstLabel: {
      type: String,
      default: '',
    },
    firstValue: {
      type: String,
      default: '',
    },
    model: {
      type: [String, Number, Boolean, Array],
      required: true,
    },
    classes: {
      type: String,
      default: '',
    },
    valueKey: {
      type: [String, Number],
      required: true,
    },
    displayKey: {
      type: String,
      required: true,
    },
    options: {
      type: Array,
      required: true,
    },
    isRequired: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['valueUpdated'],

  data() {
    return {
      modelValue: this.model,
    }
  },
  computed: {
    sortedOptions() {
      return this.options
        .slice()
        .sort((a, b) => a[this.displayKey].localeCompare(b[this.displayKey]))
    },
  },
  watch: {
    model(newValue) {
      this.modelValue = newValue
    },
  },
}
</script>
